import {
  getLocalSearchParams,
  getSaveInstanceState,
  localRead,
  localSave, routeEqual, routeHasExist,
  setLocalSearchParams,
  setSaveInstanceState
} from '../../utils/util'
import {
  getBreadCrumbList, getHomeRoute, getNextRoute,
  getRouteTitleHandled,
  getTagNavListFromLocalstorage,
  setTagNavListInLocalstorage
} from '@/libs/util'
import router from '@/router'
import config from '@/config'

const {homeName} = config

const closePage = (state, route) => {
  const nextRoute = getNextRoute(state.tagNavList, route)
  state.tagNavList = state.tagNavList.filter(item => {
    return !routeEqual(item, route)
  })
  router.push(nextRoute)
}

export default {
  state: {
    menuId: parseInt(localRead('menuId')),
    menuTitle: localRead('menuTitle') || '',
    menuPath: localRead('menuPath') || '',
    menuSecondTitle: localRead('menuSecondTitle') || '', // 二级
    menuSecondPath: localRead('menuSecondPath') || '',
    menuThreeTitle: localRead('menuThreeTitle') || '', // 三级
    menuThreePath: localRead('menuThreePath') || '',

    menuIndex: parseInt(localRead('menuIndex')) || 0,
    searchParams: getLocalSearchParams(), // 页面相关搜索
    saveInstanceState: getSaveInstanceState(),

    breadCrumbList: [],
    tagNavList: [],
    homeRoute: {},
  },
  getter: {},
  mutations: {
    setSaveInstanceState (state, {key, saveData}) {
      let saveInstanceState = state.saveInstanceState
      saveInstanceState[key] = saveData
      state.saveInstanceState = saveInstanceState
      setSaveInstanceState(saveInstanceState)
    },
    changeMenuId (state, id) {
      state.menuId = parseInt(id)
      localSave('menuId', id)
    },
    changeMenuTitle (state, title) {
      state.menuTitle = title
      localSave('menuTitle', title)
    },
    changeMenuPath (state, menuPath) {
      state.menuPath = menuPath
      localSave('menuPath', menuPath)
    },
    changeMenuSecondTitle (state, menuSecondTitle) {
      state.menuSecondTitle = menuSecondTitle
      localSave('menuSecondTitle', menuSecondTitle)
    },
    changeMenuSecondPath (state, menuSecondPath) {
      state.menuSecondPath = menuSecondPath
      localSave('menuSecondPath', menuSecondPath)
    },
    changeMenuIndex (state, menuIndex) {
      state.menuIndex = menuIndex
      localSave('menuIndex', menuIndex)
    },
    changeSearchParams (state, params) {
      state.searchParams = params
      setLocalSearchParams(params)
    },
    changeMenuThreeTitle (state, menuThreeTitle) {
      state.menuThreeTitle = menuThreeTitle
      localSave('menuThreeTitle', menuThreeTitle)
    },
    changeMenuThreePath (state, menuThreePath) {
      state.menuThreePath = menuThreePath
      localSave('menuThreePath', menuThreePath)
    },
    setTagNavList (state, list) {
      let tagList = []
      if (list) {
        tagList = [...list]
      } else tagList = getTagNavListFromLocalstorage() || []
      if (tagList[0] && tagList[0].name !== homeName) tagList.shift()
      let homeTagIndex = tagList.findIndex(item => item.name === homeName)
      if (homeTagIndex > 0) {
        let homeTag = tagList.splice(homeTagIndex, 1)[0]
        tagList.unshift(homeTag)
      }
      state.tagNavList = tagList
      setTagNavListInLocalstorage([...tagList])
    },
    closeTag (state, route) {
      let tag = state.tagNavList.filter(item => routeEqual(item, route))
      route = tag[0] ? tag[0] : null
      if (!route) return
      closePage(state, route)
    },
    addTag (state, {route, type = 'unshift', index},) {
      let router = getRouteTitleHandled(route)
      if (!routeHasExist(state.tagNavList, router)) {
        if (type === 'push') {
          // state.tagNavList.push(router)
          //index, 控制打开标签的位置,当前页后一页
          if (!index) {
            index = state.tagNavList.length
          }
          state.tagNavList.splice(index, 0, router)
        } else {
          if (router.name === homeName) state.tagNavList.unshift(router)
          else {
            if (!index) {
              index = state.tagNavList.length
            }
            state.tagNavList.splice(index, 0, router)
          }
        }
        setTagNavListInLocalstorage([...state.tagNavList])
      } else {
        if (type === 'push') {
          let index = state.tagNavList.findIndex(e => {
            return router.name === e.name
          })
          state.tagNavList.splice(index, 1, router)
        }
        setTagNavListInLocalstorage([...state.tagNavList])
      }

    },
    setBreadCrumb (state, route) {
      state.breadCrumbList = getBreadCrumbList(route, state.homeRoute)
    },
    setHomeRoute (state, routes) {
      state.homeRoute = getHomeRoute(routes, homeName)
    },
  },
  actions: {
    handleSaveMenuThreeTitle ({commit}, menuThreeTitle) {
      commit('changeMenuThreeTitle', menuThreeTitle)
    },
    handleSaveMenuThreePath ({commit}, menuThreePath) {
      commit('changeMenuThreePath', menuThreePath)
    },
    handleSaveInstanceState ({commit}, {key, saveData}) {
      commit('setSaveInstanceState', {key, saveData})
    },
    changeMenuId ({commit}, id) {
      commit('changeMenuId', id)
    },
    changeMenuTitle ({commit}, menuTitle) {
      commit('changeMenuTitle', menuTitle)
    },
    changeMenuPath ({commit}, menuPath) {
      commit('changeMenuPath', menuPath)
    },
    changeMenuSecondTitle ({commit}, menuSecondTitle) {
      commit('changeMenuSecondTitle', menuSecondTitle)
    },
    changeMenuSecondPath ({commit}, menuSecondPath) {
      commit('changeMenuSecondPath', menuSecondPath)
    },
    changeMenuIndex ({commit}, menuIndex) {
      commit('changeMenuIndex', menuIndex)
    },
    changeSearchParams ({commit}, params) {
      commit('changeSearchParams', params)
    },
  }
}
